import { z } from 'zod';

export const GetSupplierRoleSummaryQuerySchema = z.object({
  placeId: z.uuid().optional(),
});

export type GetSupplierRoleSummaryQuery = z.infer<typeof GetSupplierRoleSummaryQuerySchema>;

export const SupplierRoleRecentPurchaseSchema = z.object({
  id: z.uuid(),
  status: z.string(),
  totalCents: z.string(),
  createdAt: z.iso.datetime(),
});

export type SupplierRoleRecentPurchase = z.infer<typeof SupplierRoleRecentPurchaseSchema>;

export const SupplierRoleSummaryResponseSchema = z.object({
  supplierRoleId: z.uuid(),
  totalPurchasedCents: z.string(),
  purchaseOrderCount: z.number().int().nonnegative(),
  recentPurchases: z.array(SupplierRoleRecentPurchaseSchema),
  payables: z.object({
    openCents: z.string(),
    overdueCents: z.string(),
  }),
  skuCount: z.number().int().nonnegative(),
  averageLeadTimeDays: z.number().nullable(),
  externalRequests: z.object({
    openCount: z.number().int().nonnegative(),
    totalCount: z.number().int().nonnegative(),
  }),
});

export type SupplierRoleSummaryResponse = z.infer<typeof SupplierRoleSummaryResponseSchema>;
